import {fromJS, Map } from 'immutable';
import config from 'config';
import actions from 'redux/constants/admin/documents';
import history from '../../../../history';
import {checkJsonResponse, checkJsonResponseWithMessage,  logErrorConsole} from 'utils/actions';

export const documentsAreLoading = (data) => ({
  type: actions.DOCUMENTS_ARE_LOADING,
  data
});

export const documentIsSubmitting = (data) => ({
  type: actions.DOCUMENT_IS_SUBMITTING,
  data
});

export const documentCreateFailed = (data) => ({
  type: actions.DOCUMENT_CREATE_FAILED,
  data
}) 

export const limitMaxSize = (data) => ({
  type: actions.LIMIT_MAX_SIZE,
  data
})

export const changeDocumentFile = (data) => (dispatch) => {
  if (data.files[0].size > config.maxFileSize){
     dispatch(limitMaxSize(true))
     return;
  }
  dispatch(limitMaxSize(false))
  const file = data.files[0];
  dispatch({
    type: actions.CHANGE_DOCUMENT_FILE,
    data: file,
  });
};

export const changeDocumentValue = (data, key) => ({
	type: actions.SET_DOCUMENT_ITEM_VALUE,
	key,
	data 
});

export const documentChangeItem = (data) => ({
	type: actions.SET_DOCUMENT_ITEM,
	data
});

export const documentCleanStore = () => (dispatch) => {
  dispatch(documentChangeItem(new Map({
    name: '',
    number: '',
    description: '',
    attachment: undefined
  })));
}

export const documentCleanErrors = () => ({
  type: actions.DOCUMENT_CLEAN_ERRORS
})

export const submitNewDocument = (url, id) => (dispatch, getState) => {
  dispatch(documentIsSubmitting(true));
  dispatch(documentCreateFailed(false));
  const formData = new FormData();
  formData.append('name', getState().adminDocuments.get('documentItem').get('name'));
  formData.append('number', getState().adminDocuments.get ('documentItem').get('number'));
  formData.append('description', getState().adminDocuments.get('documentItem').get('description'));

  if (id === undefined) {
    formData.append('attachment', getState().adminDocuments.get('documentFile'));
  }

  if (id) {
    if (getState().adminDocuments.get('documentFile') !== undefined) {
      formData.append('attachment', getState().adminDocuments.get('documentFile'));
    }
  }
  let method = id ? 'PATCH' : 'post';
  let path = id ? `${config.apiHost}/document/${id}/` : `${config.apiHost}/document/`;

  const options = {
    method,
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
    body: formData
  }

  fetch(path, options)
  .then(checkJsonResponseWithMessage)
  .then((json) => {
    history.push(`${url}${json.id}`);
  })
  .catch(e => {
    if (e.status === 413){
      console.log(e.status+"error 413");
    }
    dispatch(documentCreateFailed(e));
  })
  .then(() => {
    dispatch(documentIsSubmitting(false))
  })
}

export const deleteDocument = (id) => (dispatch, getState) => {
  const options = {
    method: "delete",
    headers: {
       "Authorization": "Token " + getState().auth.get('token'),
    }
  };

  fetch(`${config.apiHost}/document/${id}/`, options)
  .then(response => {
    if (!response.ok) {
      throw Error(response.statusText);
    }
    return null;
  })
  .then(() => {
    history.push(`/admin/documents`);
  })
  .catch(e => {
    console.log(e);
  })
}

export const loadDocuments = (limit=25, offset=0) => (dispatch, getState) => {
  dispatch(documentsAreLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/document/?limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_DOCUMENTS,
      data
    });
    dispatch(documentsAreLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(documentsAreLoading(false));
  })
};

export const searchDocuments = (search, start_date, end_date, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(documentsAreLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/document/?search=${search}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_DOCUMENTS,
      data
    });
    dispatch(documentsAreLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(documentsAreLoading(false));
  })
};

export const searchDocumentsByDate = (date) => (dispatch, getState) => {
  const dateFormat = date.format("YYYY-MM-DD");
  dispatch(documentsAreLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/document/?date_created=${dateFormat}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_DOCUMENTS,
      data
    });
    dispatch(documentsAreLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(documentsAreLoading(false));
  })
};


export const loadDocumentsPublic = (limit=25, offset=0, name="") => (dispatch, getState) => {
  dispatch(documentsAreLoading(true));
  fetch(`${config.apiHost}/document/?limit=${limit}&offset=${offset}&current_status=public&search=${name}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_DOCUMENTS,
      data
    });
    dispatch(documentsAreLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(documentsAreLoading(false));
  })
};

export const searchPublicDocuments = (name="", start_date, end_date, limit, offset) => (dispatch, getState) => {
  const date_start = start_date.format("YYYY-MM-DDTHH:mm:ss");
  const date_end = end_date.format("YYYY-MM-DDT23:59:59");
  dispatch(documentsAreLoading(true));
  fetch(`${config.apiHost}/document/?current_status=public&search=${name}&date_created__range=${date_start}Z,${date_end}Z&limit=${limit}&offset=${offset}`)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);

    dispatch({
      type: actions.LOAD_DOCUMENTS,
      data
    });
    dispatch(documentsAreLoading(false));
  })
  .catch(logErrorConsole)
  .then(() => {
    dispatch(documentsAreLoading(false));
  })
};


export const loadDocumentDetail = (id) => (dispatch, getState) => {
  dispatch(documentsAreLoading(true));
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
  }
  fetch(`${config.apiHost}/document/${id}/`,options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json);
    dispatch(documentsAreLoading(false));
    dispatch(documentChangeItem(data));
  })
  .catch(logErrorConsole)
};

export const loadDocumentJournal = (id) => (dispatch, getState) => {
  const options = {
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    }
  }
  fetch(`${config.apiHost}/document_journal/?document=${id}`, options)
  .then(checkJsonResponse)
  .then((json) => {
    const data = fromJS(json.results);
    dispatch({
      type: actions.LOAD_DOCUMENT_JOURNAL,
      data
    })
  })
  .then(logErrorConsole)
}

export const changeDocumentStatus = (id) => (dispatch, getState) => {
  const formData = new FormData();
  formData.append('current_status', getState().adminDocuments.get('documentItem').get('current_status'));
  const options = {
    method: 'PATCH',
    headers: {
      "Authorization": "Token " + getState().auth.get('token'),
    },
    body: formData,
  }
  fetch(`${config.apiHost}/document/${id}/`, options)
  .then(checkJsonResponse)
  .then((json) => {

    })
  .then(logErrorConsole)
}



// WEBPACK FOOTER //
// ./src/redux/actions/admin/documents/index.js